@for (toast of toastService.toasts; track toast) {
  <ngb-toast
    [class]="toast.classname"
    [autohide]="!toast.persistent"
    [delay]="toast.delay || 5000"
    (hidden)="toastService.remove(toast)">

    @if (toast.persistent) {
      <div class="d-flex justify-content-between align-items-center mb-2" ngbToastHeader>
        <strong class="me-auto">{{ toast.header }}</strong>
        <button type="button" class="btn-close" aria-label="Close" (click)="toastService.remove(toast)"></button>
      </div>
    }

    @if (isTemplate(toast)) {
      <ng-template [ngTemplateOutlet]="toast.textOrTpl"></ng-template>
    } @else {
      <span [innerHTML]="toast.textOrTpl"></span>
    }
    
  </ngb-toast>
}